// TODO: remove this and use directly from ../../lib/components
module.exports = require('../../lib/components/index');
